import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const GamingService = {
  // Progression
  async getProgression() {
    const { data } = await axios.get(`${API_URL}/game/progression`);
    return data;
  },

  async awardXP(xpAmount, reason = 'gameplay') {
    const { data } = await axios.post(`${API_URL}/game/progression/award-xp`, {
      xp_amount: xpAmount,
      reason
    });
    return data;
  },

  async unlockSkill(skillId) {
    const { data } = await axios.post(`${API_URL}/game/progression/unlock-skill`, {
      skill_id: skillId
    });
    return data;
  },

  async getAllSkills() {
    const { data } = await axios.get(`${API_URL}/game/skills`);
    return data;
  },

  async getSkillTree(treeType) {
    const { data } = await axios.get(`${API_URL}/game/skills/${treeType}`);
    return data;
  },

  // Achievements
  async getAchievements() {
    const { data } = await axios.get(`${API_URL}/game/achievements`);
    return data;
  },

  async getMyAchievements() {
    const { data } = await axios.get(`${API_URL}/game/achievements/mine`);
    return data;
  },

  // Leaderboard
  async getLeaderboard(limit = 100) {
    const { data } = await axios.get(`${API_URL}/game/leaderboard?limit=${limit}`);
    return data;
  },

  // Game assets
  async getVehicles() {
    const { data } = await axios.get(`${API_URL}/game/vehicles`);
    return data;
  },

  async getMaps() {
    const { data } = await axios.get(`${API_URL}/game/maps`);
    return data;
  },

  async getWeapons() {
    const { data } = await axios.get(`${API_URL}/game/weapons`);
    return data;
  }
};